import Axios from './Axios'
import Lodash from './Lodash'
import SharedComponents from './SharedComponents'
import Permissions from './Permissions'
import Forms from './Forms'
import ProgressBar from './ProgressBar'
import Lang from './Lang';
import Snotify from './Snotify';
import VueSelect from './VueSelect';

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.use(Lodash);
        Vue.use(Axios);
        Vue.use(SharedComponents);        
        Vue.use(Permissions);
        Vue.use(Forms);
        Vue.use(Lang);        
        Vue.use(ProgressBar);
        Vue.use(Snotify);
        Vue.use(VueSelect);

    }
}
